<template>
  <div>
    <!--- Navigator-->
    <b-row>
      <b-col cols="3">
        <h3><b>จัดการลูกค้า</b></h3>
        <small>       
          <router-link to="/setting/customer/warranty/owner">ลูกค้า</router-link>  > 
           <b>{{ mode == 'create' ? 'เพิ่มลูกค้า' :'แก้ไขลูกค้า' }}</b>
          </small>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">       
        <b-button
          v-if="customerPermission=='create' || customerPermission=='edit'"
          variant="primary"
          size="sm"
          style="height: 35px"
          class="mr-1"
          :disabled="isLoading"
          @click="save"

        >
          <feather-icon icon="SaveIcon" />
          บันทึก
        </b-button>

        <b-button
          variant="outline-dark"
          size="sm"
          @click="$router.push('/setting/customer/warranty/owner')"
          style="height: 35px"
        >
          <feather-icon icon="ArrowLeftIcon" />
          ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <!--- Navigator-->

    <b-row class="mt-1">
      <b-col cols="12">
        <!-- START SECTION FORM วันเดินทาง--->
        <b-card>
          <b-row >
            <b-col><h2><b>{{ mode == 'create' ? 'เพิ่มลูกค้า' :'แก้ไขลูกค้า' }}</b></h2></b-col>
          </b-row>

          <!--- START (ชื่อลูกค้า) --->
          <b-row class="mt-2">
            <b-col md="3" class="">
              <label>ชื่อลูกค้า <span class="text-danger">*</span></label>
              <b-form-input
                placeholder="Vserv"
                size="sm"
                value="Vserv"
                v-model="ownerData.ownerName"
              />
            </b-col>
       
            <b-col md="2" class="">
              <label>สถานะ</label>
              <b-form-group>
                <b-form-radio-group
                  v-model="ownerData.status"
                  :options="statusOptions"
                  name="radio-inline"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!--- END (ชื่อลูกค้า) --->

          <!--- START ROW รายละเอียด --->
          <b-row class="mt-1">
            <b-col md="12">
              <label>รายละเอียด</label>
              <b-form-textarea
                id="textarea-default"
                placeholder="รายละเอียด"
                rows="2"
                size="sm"
                v-model="ownerData.detail"
              />
            </b-col>
          </b-row>
          <!--- END รายละเอียด --->
        </b-card>
        <!-- END SECTION FORM วันเดินทาง--->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BInputGroupPrepend,
  BInputGroupAppend,
  BInputGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

//SERVICES
import CustomerService from "@/services/setting/customer";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BButton,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BInputGroupPrepend,
    BInputGroupAppend, 
    BFormRadioGroup,
  },
  data() {
    return { 
      statusOptions: [
        { text: 'เปิด', value: 1 },
        { text: 'ปิด', value: 0 },        
      ],
      ownerData:{       
            ownerName: "",
            detail: "",
            status:1
      },
      isLoading:false
    };
  },  

  computed:{
    customerPermission () {
      const permission = this.$store.getters["user/getPermissionPage"]("ST003-1")
      if(permission=="disable"){
        localStorage.removeItem("userData")
        window.location.href="/not-authorized"
      }
      return permission
    },
    mode(){
      const ownerId = this.$route.query.oid
      if(ownerId){
        return "edit"
      }
      return "create"
    },
    paramOwnerId(){      
      return this.$route.query.oid
    }
  },



  methods: { 
    async save(){      
      if(!this.ownerData.ownerName){
        alert("กรุณากรอกชื่อลูกค้า")
        return
      }

      if(this.mode == 'create'){
        await this.insert()
      }else{
        await this.update()
      }
    }, 

    async getCustomerOwnerDetail(){
      const result = await CustomerService.GetCustomerOwnerById(this.paramOwnerId)
      this.ownerData = result.data
    },
    async insert(){
      this.isLoading =true
      const result = await CustomerService.InsertCustomerOwner(this.ownerData)
      if (result.status == "success") {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Owner`,
              icon: "CheckIcon",
              variant: "success",
              text: `เพิ่มรายการเรียบร้อย`,
            },
          });
          this.$router.push("/setting/customer/warranty/owner")        
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Owner`,
              icon: "XIcon",
              variant: "danger",
              text: `พบปัญหาในการเพิ่มรายการ`,
            },
          });
        }

      this.isLoading = false
      
    },
    async update(){ 
      this.isLoading =true
      const result = await CustomerService.UpdateCustomerOwner(this.ownerData,this.paramOwnerId )
      if (result.status == "success") {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Owner`,
              icon: "CheckIcon",
              variant: "success",
              text: `แก้ไขรายการเรียบร้อย`,
            },
          });
          this.$router.push("/setting/customer/warranty/owner")        
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Owner`,
              icon: "XIcon",
              variant: "danger",
              text: `พบปัญหาในการแก้ไขรายการ`,
            },
          });
        }
        this.isLoading = false
    }
  },

  mounted(){
    if(this.mode == "edit"){
      this.getCustomerOwnerDetail()
    }    
  }
};
</script>

